export const ROUTING = {
	detailsPath: '/details/:id',
	addLocationPath: '/add-location/:id',
	previousLocations: '/previous-locations/:id',
};
